import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Modal from "react-responsive-modal"
import moment from "moment"
import helpers from "helpers/helpers"
import settings from "settings"
import classNames from "classnames"

const ARCMasterHistory = (props) => {
	const [showing, setShowing] = useState([])
	const Display = () => {
		let d = props.data
		let latest = _.cloneDeep(d)
		delete latest.arc_history
		if (!props.data) return <div>Loading...</div>
		let history = []
		_.forEach(d.arc_history, (v, k) => {
			let u = _.find(props.payload.users, { id: v.user })
			let diff
			if (d.arc_history[k - 1]) {
				diff = helpers.objectDiff(v, d.arc_history[k - 1])
			}
			let prev = v.data
			const tables = []
			let standOut = "bg-red-600 font-bold text-white px-2 py-1"

			let buildCard = () => {
				const processValue = (value, key) => {
					let hasDiff = false
					if (diff && _.has(diff.data, key)) hasDiff = true
					if (key === "file") {
						if (value) {
							const fileUrl = value.startsWith("/") ? value : `/${value}`
							return (
								<a href={`${settings.s3}${fileUrl}`} target="_blank">
									{value}
								</a>
							)
						}
					}
					if (key === "addedDate") {
						return moment.unix(value).format("MM/DD/YY h:mm A")
					}
					if (Array.isArray(value)) {
						const headers = value[0] && typeof value[0] === "object" ? Object.keys(value[0]) : ["Value"]
						const tableContent = value.map((item, index) => {
							if (typeof item === "object") {
								const cells = Object.entries(item)
									.filter(([k, v]) => !_.isObject(v) || _.isNull(v))
									.map(([k, v]) => {
										let val = v
										if (k === "file") {
											const fileUrl = v.startsWith("/") ? v : `/${v}`
											val = (
												<a
													className="inline bg-blue text-xs text-white rounded-lg px-2 py-1"
													href={`${settings.s3}${fileUrl}`} target="_blank">
													View File
												</a>
											)
										}
										if (k === "property") {
											let lookup = _.find(props.payload.public.properties, {
												id: v,
											})
											if (lookup) val = lookup.name
										}
										if (k === "lot_type") {
											let lookup = _.find(props.payload.public.lot_types, {
												id: v,
											})
											if (lookup) val = lookup.name
										}
										if (k === "user") {
											let lookup = _.find(props.payload.users, { id: v })
											if (lookup) val = `${lookup.first} ${lookup.last}`
										}
										return (
											<td key={`${k}-${v}`} className="border px-2 py-1">
												{val}
											</td>
										)
									})
								return <tr key={index}>{cells}</tr>
							} else if (key === "classifications") {
								try {
									let lookup = _.find(props.payload.public?.options?.floorplan_classifications, {
										id: item,
									})
									if (lookup) item = lookup.name
								} catch (e) {
									console.log(e)
								}
							} else if (key === "properties") {
								let lookup = _.find(props.payload.public.properties, { id: item })
								if (lookup) item = lookup.name
							}
							return (
								<tr key={index}>
									<td className="border px-2 py-1">{String(item)}</td>
								</tr>
							)
						})
						let table = (
							<div key={`table-container-${k}-${key}`}>
								<div
									className={classNames("font-semibold text-white mb-2 py-1 px-2 mt-3", {
										"bg-red-600 text-white": hasDiff,
										"bg-blue": !hasDiff,
									})}>
									{_.startCase(key)}
								</div>
								<table className="w-full border-collapse border" key={`table-${k}-${key}`}>
									<thead>
										<tr>
											{headers.map((header) => (
												<th key={header} className="border px-2 py-1 bg-slate-200">
													{_.startCase(header)}
												</th>
											))}
										</tr>
									</thead>
									<tbody>{tableContent}</tbody>
								</table>
							</div>
						)
						//if(isLatest) latestTable.push(table)
						//else
						tables.push(table)
						return null
					}
					return _.isNull(value) ? "" : String(value)
				}

				const entries = _.chain(prev)
					.toPairs()
					.filter(([key, val]) => (!_.isObject(val) || _.isNull(val) || Array.isArray(val)) && val)
					.value()

				//const friendlyName = (k) => _.chain(k).split("_").map(_.capitalize).join(" ").value()
				const friendlyName = (k) => {
					if (k.match(/[A-Z]/)) {
						// Handle camelCase
						return k.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())
					}
					// Handle snake_case
					return _.chain(k).split("_").map(_.capitalize).join(" ").value()
				}

				const rows = []
				//? Build the `tables` first, then delete the entries that are arrays, then move forward.
				_.forEach(entries, (entry, index) => {
					processValue(entry[1], entry[0])
				})
				//? now delete the entries that are arrays
				_.remove(entries, ([key, value]) => Array.isArray(value))
				_.forEach(entries, (entry, index) => {
					if (index % 3 === 0) {
						const [key, value] = entry
						const nextEntry1 = entries[index + 1]
						const nextEntry2 = entries[index + 2]
						const friendlyKey1 = friendlyName(key)
						const isDifferent1 = diff && _.has(diff.data, key)
						const friendlyKey2 = nextEntry1 ? friendlyName(nextEntry1[0]) : ""
						const isDifferent2 = nextEntry1 ? diff && _.has(diff.data, nextEntry1[0]) : false
						const friendlyKey3 = nextEntry2 ? friendlyName(nextEntry2[0]) : ""
						const isDifferent3 = nextEntry2 ? diff && _.has(diff.data, nextEntry2[0]) : false
						if (value || (nextEntry1 && nextEntry1[1]) || (nextEntry2 && nextEntry2[1])) {
							rows.push(
								<React.Fragment key={`row-${index}`}>
									{value && processValue(value, key) !== null && (
										<>
											<div className="font-semibold">{friendlyKey1}</div>
											<div className={isDifferent1 ? standOut : ""}>
												{processValue(value, key)}
											</div>
										</>
									)}
									{nextEntry1 &&
									nextEntry1[1] &&
									processValue(nextEntry1[1], nextEntry1[0]) !== null ? (
										<>
											<div className="font-semibold">{friendlyKey2}</div>
											<div className={isDifferent2 ? standOut : ""}>
												{processValue(nextEntry1[1], nextEntry1[0])}
											</div>
										</>
									) : (
										<>
											<div></div>
											<div></div>
										</>
									)}
									{nextEntry2 &&
									nextEntry2[1] &&
									processValue(nextEntry2[1], nextEntry2[0]) !== null ? (
										<>
											<div className="font-semibold">{friendlyKey3}</div>
											<div className={isDifferent3 ? standOut : ""}>
												{processValue(nextEntry2[1], nextEntry2[0])}
											</div>
										</>
									) : (
										<>
											<div></div>
											<div></div>
										</>
									)}
								</React.Fragment>
							)
						}
					}
				})
				return rows
			}
			history.push(
				<div
					key={`archistory-${k}`}
					className="px-2 py-3 border border-dashed border-slate-600 bg-slate-100 my-2 text-slate-800 text-sm">
					<div className="flex items-center justify-between">
						<p className="p-2 flex items-center">
							<span className="text-green-700 pr-2 font-bold">
								{u.first} {u.last}
							</span>
							<span className="border-dashed border border-slate-500 text-xs cursor-help py-1 px-2">
								{v.action}
							</span>
							<span
								className="btn text-xs ml-2"
								onClick={() => {
									if (showing.includes(k)) {
										setShowing(showing.filter((item) => item !== k))
									} else {
										setShowing([...showing, k])
									}
								}}>
								{showing.includes(k) ? "Hide" : "Show"}
							</span>
						</p>
						<p className="text-xs font-bold">
							{k === d.arc_history.length - 1 ? (
								<span className="px-2 py-[1px] text-xs rounded-lg bg-green-700 text-white mr-1">
									Latest
								</span>
							) : null}
							{moment.unix(v.addedDate).format("MM/DD/YY h:mm A")}
						</p>
					</div>
					<div
						className={classNames("h-0 overflow-hidden", {
							"h-auto": showing.includes(k),
						})}>
						<div className="grid grid-cols-6 gap-2 mt-2 text-xs">{buildCard(v)}</div>
						{tables.length > 0 && <div className="mt-4">{tables}</div>}
					</div>
				</div>
			)
			//? If this is the last item in the history, then push in the current values.
			// I dont think this even needs to be here.
			/* if (k === d.arc_history.length - 1) {
				// Create diff between current values and last history entry
				const lastHistoryDiff = helpers.objectDiff(latest, v.prev)
				const buildResult = buildCard(latest, lastHistoryDiff)
				history.push(
					<div
						key={`archistory-${k + 1}`}
						className="px-2 py-3 border border-dashed border-slate-600 bg-slate-100 my-2 text-slate-800 text-sm">
						<div className="flex items-center justify-between">
							<p className="p-2 flex items-center">
								<span className="text-green-700 pr-2 font-bold">Current Values</span>
								<span
									className="btn text-xs ml-2"
									onClick={() => {
										if (showing.includes(k + 1)) {
											setShowing(showing.filter((item) => item !== k + 1))
										} else {
											setShowing([...showing, k + 1])
										}
									}}>
									{showing.includes(k + 1) ? "Hide" : "Show"}
								</span>
							</p>
							<p className="text-xs font-bold">{moment().format("MM/DD/YY h:mm A")}</p>
						</div>
						<div
							className={classNames("h-0 overflow-hidden", {
								"h-auto": showing.includes(k + 1),
							})}>
							<div className="grid grid-cols-6 gap-2 mt-2 text-xs">{buildResult}</div>
							{latestTable.length > 0 && <div className="mt-4">{latestTable}</div>}
						</div>
					</div>
				)
			} */
		})
		if (history.length === 0) {
			history.push(
				<>
					<div className="px-2 py-2 border border-neutral-200">
						<p className="text-sm text-neutral-600">No history found</p>
					</div>
				</>
			)
		}
		return (
			<div>
				<h1 className="flex items-center mb-3">
					<i className="fa-regular fa-clock-rotate-left pr-2"></i>
					<span>Plan History: {props.data.name}</span>
				</h1>
				{history}
			</div>
		)
	}

	return (
		<Modal
			classNames={{ modal: "modalForm mid" }}
			open={props.showHistory}
			onClose={() => {
				props.onClose()
				setShowing([])
			}}
			center>
			<Display />
		</Modal>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ARCMasterHistory)
